import {getTestProps} from '@benchling/js-test-utils';
import {Box} from '@mantine/core';
import React from 'react';

import DataConnector from 'connect/DataConnector';
import OnboardingConstants from 'constants/OnboardingConstants';
import * as SpaceUtil from 'growth/SpaceUtil';
import HomeDashboardStore from 'home-dashboard/HomeDashboardStore';
import ChecklistItemListing from 'onboarding/ChecklistItemListing';
import {
  AI_AGENTS_CHECKLIST_KEY,
  AI_AGENTS_CHECKLIST_TITLE,
  NUEModuleEnhancedProps,
} from 'onboarding/OnboardingConstants';
import {makeAIAgentsItems, trackChecklistCollapsed} from 'onboarding/OnboardingUtils';
import EntityStore from 'stores/EntityStore';

class AIAgentsNUEModuleConnector extends DataConnector<{}, NUEModuleEnhancedProps> {
  override shouldSubscribeToRedux = false;
  override stores = [HomeDashboardStore];

  enhanceProps(): NUEModuleEnhancedProps {
    const module = this.homeDashboardStore().getNUEModuleState(OnboardingConstants.MODULES.AI_AGENTS);
    return {
      collapsed: module?.collapsed ?? false,
      completed: module?.completed ?? false,
      openIndex: module?.openIndex ?? null,
      tasks: module?.tasks ?? null,
      visible: !module?.acknowledgedCompleted && !module?.dismissed,
    };
  }
}

function handleChangeCollapsed(isCollapsed: boolean): void {
  trackChecklistCollapsed(isCollapsed, AI_AGENTS_CHECKLIST_KEY, AI_AGENTS_CHECKLIST_TITLE);
}

export function AIAgentsNUEModule({
  tasks,
  completed,
  collapsed,
  openIndex,
  visible,
}: NUEModuleEnhancedProps): JSX.Element | null {
  if (!visible || tasks == null) {
    return null;
  }

  const currentUser = EntityStore.currentUser();
  const canEarnSpace = Boolean(currentUser) && !SpaceUtil.hasUnlimitedSpace(currentUser);

  return (
    <Box
      pos="relative"
      // Give the expanded card a fixed width; leave the collapsed pill sized to its content so it
      // stays flush against the right edge instead of left-aligning inside a wider box.
      w={collapsed ? undefined : '270px'}
      {...getTestProps({component: 'AIAgentsNUEModule', element: 'root'})}
    >
      <ChecklistItemListing
        title="Explore AI agents"
        module={OnboardingConstants.MODULES.AI_AGENTS}
        listItems={makeAIAgentsItems(tasks, completed, canEarnSpace)}
        collapsed={collapsed ?? false}
        completed={completed}
        onChangeCollapsed={handleChangeCollapsed}
        fixedSize={false}
        openIndex={openIndex}
      />
    </Box>
  );
}

export default AIAgentsNUEModuleConnector.connect(AIAgentsNUEModule);
